<img *ngIf="reactionAnimation?.imageUrl"
  [src]="reactionAnimation?.imageUrl"
  [style.opacity]="reactionAnimation.opacity"
  [style.transform-origin]="reactionAnimation?.animationOriginX + ' ' + reactionAnimation?.animationOriginY"
  [style.transform]="reactionAnimation?.fullScale"
/>
